import React from 'react';
import SEO from '../seo/seo';
import { getImage } from '../../server/server';
import Loading from '../../common/Loading';

function ProductNameAndPrice({
	name = '',
	price = '',
	currency = '',
	product,
	orderProgress = false,
	editCartMode = false,
	addItemToCart = () => {},
	disabledButton = false,
	designPrice = 0,
	hasSale = false,
	oldPrice = '',
}: {
	name: string;
	price: string;
	currency: string;
	product: any;
	orderProgress?: boolean;
	editCartMode?: boolean;
	addItemToCart?: () => void;
	disabledButton?: boolean;
	designPrice?: number;
	hasSale?: boolean;
	oldPrice?: string;
}) {
	const seo = product.seo;
	const image = !!product?.files?.length ? product?.files[0] : null;

	return (
		<div className="flex flex-col gap-[10px]">
			<SEO title={seo?.metaTitle} description={seo?.metaDescription} keywords={seo?.metaKeywords} price={price} currency={currency} imageUrl={image ? getImage(image?.file?.id) : ''} imageAlt={seo?.metaTitle} urlType="product" />
			<h1 className="text-[28px] font-[400]">{name}</h1>
			<div className="flex flex-row items-center gap-[10px]">
				{hasSale && (
					<p className="text-[16px] font-normal -mt-[6px] line-through">
						{parseInt(oldPrice) < 0 ? '' : oldPrice} <span className="lowercase">{currency}</span>
					</p>
				)}
				<p className={`text-[20px] font-normal -mt-[6px] ${hasSale ? 'text-[#F54126]' : 'text-[#21187F]'}`}>
					{parseInt(price) < 0 ? '' : price} <span className="lowercase">{currency}</span>
				</p>
			</div>
		</div>
	);
}

export default ProductNameAndPrice;
